var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCoverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 36.375C13.125 39.0674 15.2237 41.25 17.8125 41.25C20.4013 41.25 22.5 39.0674 22.5 36.375V20.625M22.5 20.625C19.4809 20.625 15 22.5 15 22.5C15 22.5 12.3941 20.625 9.375 20.625C6.35593 20.625 3.75 22.5 3.75 22.5C3.75 12.1447 12.1447 3.75 22.5 3.75C32.8553 3.75 41.25 12.1447 41.25 22.5C41.25 22.5 38.6441 20.625 35.625 20.625C32.6059 20.625 30 22.5 30 22.5C30 22.5 25.5191 20.625 22.5 20.625Z",
    stroke: "#383ECB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoverage);
export default __webpack_public_path__ + "static/media/icon-coverage.d21c99856ce850ff330667704bc3bdba.svg";
export { ForwardRef as ReactComponent };